<template>
  <base-page :title="'Users'">
    <template #actionButton>
      <v-btn
        rounded
        outlined
        color="primary"
        :to="{ name: 'create-user' }"
        v-if="isSessionRoleAdminOrOwner"
      >
        <v-icon left>  {{ $t("generic.icon.add") }} </v-icon>

        {{ $t("user.add") }}
      </v-btn>
    </template>
    <template #main>
      <user-table />
    </template>
  </base-page>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import BasePage from "../BasePage";
import UserTable from "@/views/User/UserTable";

export default {
  components: {
    UserTable,
    BasePage,
  },
  created() {
    this.initUsers();
  },
  computed: {
    ...mapGetters(["isSessionRoleAdminOrOwner"]),
  },
  methods: {
    ...mapActions(["initUsers"]),
  },
};
</script>
